import { render } from "./ErrorBlock.vue?vue&type=template&id=7dbc6084"
import script from "./ErrorBlock.vue?vue&type=script&lang=js"
export * from "./ErrorBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__